import { clsx } from 'clsx';
import { Children, type ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Перечень с маркерами: что удалится, что останется, запреты в правилах.
 *
 * Настоящие <ul>/<li>, а не стопка абзацев: скринридер объявляет число
 * пунктов, а перед необратимым действием это важнее, чем вид.
 *
 * Цвет маркера — не украшение: на экране удаления данных рядом стоят два
 * перечня, и малиновый против бирюзового отвечает «это исчезнет» против «это
 * останется» раньше, чем прочитан заголовок раздела.
 */
export type ListTone = 'pink' | 'cyan';

const TONE: Record<ListTone, string> = {
  pink: styles.listPink,
  cyan: styles.listCyan,
};

export function List({ items, tone = 'pink' }: { items: ReactNode[]; tone?: ListTone }) {
  const shown = items.filter((item) => item !== null && item !== undefined && item !== false);
  if (shown.length === 0) return null;

  return (
    <ul className={clsx(styles.list, TONE[tone])}>
      {Children.map(shown, (item) => (
        <li className={styles.listItem}>{item}</li>
      ))}
    </ul>
  );
}
